import CheckBox from 'admin/components/atoms/CheckBox';
import Labeled from 'admin/components/atoms/Labeled';
import { randomAlphanumeric } from 'admin/utils';
import React from 'react';
import styled, { StyledComponentPropsWithRef } from 'styled-components';

type LabledProps = StyledComponentPropsWithRef<typeof Labeled>;

type Props = {
  id?: string;
  labelText?: LabledProps['labelText'];
  className?: LabledProps['className'];
  labelPosition?: LabledProps['labelPosition'];
} & StyledComponentPropsWithRef<typeof CheckBox>;

const LabeledCheckBox = ({
  labelText = '',
  className = '',
  labelPosition = 'left',
  id,
  ...rest
}: Props) => {
  const iid = id || randomAlphanumeric(16);
  return (
    <Labeled
      labelText={labelText}
      className={className}
      labelPosition={labelPosition}
      htmlFor={iid}
    >
      <CheckBox id={iid} {...rest} />
    </Labeled>
  );
};

export default styled(LabeledCheckBox)``;
